import React, { useState, useEffect } from "react";
import { IoIosTimer } from "react-icons/io";

const Timer = ({ durationInHours = 0, onTimeUp }) => {
  const durationInSeconds = durationInHours * 3600;
  const [timeLeft, setTimeLeft] = useState(durationInSeconds);
  const [isRunning, setIsRunning] = useState(false);

  useEffect(() => {
    setTimeLeft(durationInSeconds);
    setIsRunning(durationInSeconds > 0);
  }, [durationInSeconds]);

  useEffect(() => {
    let timer;
    if (isRunning) {
      timer = setInterval(() => {
        setTimeLeft((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            setIsRunning(false);
            onTimeUp?.();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => clearInterval(timer);
  }, [isRunning, onTimeUp]);

  const formatTimeParts = (time) => {
    const days = Math.floor(time / 86400); // 24h chunks become day badges
    const hours = Math.floor((time % 86400) / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = Math.floor(time % 60);
    const hh = hours.toString().padStart(2, "0");
    const mm = minutes.toString().padStart(2, "0");
    const ss = seconds.toString().padStart(2, "0");
    return { days, clock: `${hh}:${mm}:${ss}` };
  };

  const { days, clock } = formatTimeParts(timeLeft);

  if (!timeLeft) {
    return null;
  }

  return (
    <div className="px-5 py-0 my-0 ml-auto mr-0 text-black bg-transparent shadow-none rounded-xl">
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2">
          <span className="flex items-center justify-center text-black bg-transparent border border-gray-300 rounded-full h-9 w-9">
            <IoIosTimer className="w-5 h-5" />
          </span>
          <div className="flex flex-col leading-tight">
            <span className="text-[11px] uppercase tracking-[0.12em] text-gray-600">Time left</span>
            <span className="text-xl font-semibold tabular-nums">{clock}</span>
          </div>
        </div>
        {days > 0 && (
          <span className="px-3 py-1 text-xs font-semibold text-black border border-gray-300 rounded-full">
            {days} {days === 1 ? "day" : "days"}
          </span>
        )}
      </div>
    </div>
  );
};

export default Timer;